import { Box, Image, useColorMode } from '@chakra-ui/react'
import React from 'react'

function Logo() {
    const { colorMode, toggleColorMode } = useColorMode();
    console.log(colorMode)
  const isDark = colorMode === "dark";
  return (
    <Box mt={100} display='flex' flexDirection={'row'} justifyContent='center'>
        <Image position={'absolute'} ml={'100px'}mt={'200px'} height={'400px'} className='logo-solid' src={isDark ?'logo3.svg' : 'logo4.svg'} alt='text' />
        <Image  height={'500px'} className='logo-solid' src='logo.svg' alt='text' />
        
    </Box>
        
    
  )
}

export default Logo